import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.targets = document.querySelectorAll( '[data-accompany]' );

        this.el.addEventListener( 'change', () => {


            for( let  i = 0 ; i < this.targets.length; i++ ){
                this.targets[ i ].classList.toggle( 'hidden', i + 1 >= parseInt( this.el.value ) );
                this.targets[ i ].dataset.validateGroup = i + 1 < parseInt( this.el.value ) ? 'true' : 'false';
            }
            this.call( 'update', false, 'Scroll');
        });
    }
    init() {}
    destroy(){}
}
